export const universalLoves = [
  "pearl",
  "magic rock candy",
  "prismatic shard",
  "rabbits foot",
  "golden pumpkin",
];

export const universalLikes = [
  "most flowers",
  "cooked meals",
  "tree fruit",
  "gems",
  "artisan goods",
  "treasure chest",
  "rainbow shell",
  "vegetable crops",
];
